import { UserAvatar } from "components/Atoms/Avatar";
import CultureLabel from "components/Culture/CultureLabel";
import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { getCultureFromLcid } from "utilities/enumutils";

interface Props {
  user: server.dto.UserForAdminOne
}

export const userMainSection = (props: Props): FormSection => {
  const { user } = props;
  return {
    key: "userDetails",
    type: "regular",
    title: "Client",
    fields: [
      {
        key: "name",
        label: "Name",
        render: () => <div>{user.fullName}</div>,
      },
      {
        key: "photo",
        label: "Photo",
        render: () => <UserAvatar user={user} />,
      }, {
        key: "username",
        label: "Username",
        render: () => <div>{user.username}</div>,
      }, {
        key: "language",
        label: "Language",
        render: () => <CultureLabel culture={getCultureFromLcid(user.culture)} />,
      }, {
        key: "timezone",
        label: "Timezone",
        render: () => <div>({user.timeZone.utcOffset}) {user.timeZone.displayName} ({user.timeZone.value})</div>,
      }, {
        key: "email",
        label: "Email",
        render: () => <div>{user.email}</div>,
      }, {
        key: "lastActivity",
        label: "Last activity",
        render: () => <div>{user.lastActivityText}</div>,
      }
    ]
  }
}